import { DEFAULT_OPTION } from '../schemas/estimate/base-schemas.js';
/**
 * Ajoute le client comme voyageur dans la liste des passagers du devis.
 *
 * - Aucune ligne, ou première ligne vide (non liée à un passager enregistré) → on
 *   préremplit cette ligne avec le nom/prénom du client.
 * - Toutes les lignes déjà remplies (ou liées) → on ajoute une nouvelle ligne préremplie.
 *
 * Dans tous les cas la ligne cible est « déliée » (savedPassengerId = undefined) : le
 * client est un passager saisi, pas un passager enregistré réutilisé.
 */
export function applyIAmTravelerFill(form) {
    const { clientFirstName, clientLastName, newPassengers } = form.state.values;
    const rows = newPassengers ?? [];
    const emptyIndex = rows.findIndex((p) => !p.savedPassengerId && !p.firstName.trim() && !p.lastName.trim());
    if (emptyIndex !== -1) {
        form.setFieldValue(`newPassengers[${emptyIndex}].firstName`, clientFirstName);
        form.setFieldValue(`newPassengers[${emptyIndex}].lastName`, clientLastName);
        form.setFieldValue(`newPassengers[${emptyIndex}].savedPassengerId`, undefined);
        return;
    }
    form.pushFieldValue('newPassengers', {
        firstName: clientFirstName,
        lastName: clientLastName,
        birthDate: '1990-01-01',
        gender: 'MALE',
        nationality: DEFAULT_OPTION,
    });
}
